<template>
<div>
    <validation-observer>
        <b-form @submit.prevent="SimpanMaklumat">
            <h3 class="mb-0">GAJI LANTIKAN PERTAMA</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col lg="5"> Klasifikasi Perkhidmatan Pertama * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.ServClassId" :options="ServClassList" @change="runMethod()" :state="getValidation(validationContext)" style="width: 50%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col lg="5"> Skim Perkhidmatan * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SchmOfServId" :options="filteredSchmOfServList" :state="getValidation(validationContext)" style="width: 100%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row class="my-1">
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="pilih skim" :rules="{ required: true }">
                    <b-row>
                        <b-col lg="5" class="font-weight-bold"> Sistem Saraan * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Pilih Skim" name="Pilih Skim" value-field="value" text-field="text" :options="skimOptions" v-model="Obj.id_SistemSaraan" @change="runMethod2()" style="width: 45%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>

                <b-row class="my-1">
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="5"> Gred Jawatan Lantikan Pertama * </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" :state="getValidation(validationContext)" v-model="Obj.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>

                <validation-provider name="Gaji Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="5">Gaji Lantikan Pertama* </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="6">
                            <b-form-input v-model="Obj.SalGrdPertama" :state="getValidation(validationContext)"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="Tarikh Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Tarikh Lantikan Pertama* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <base-input type="date" v-model="Obj.DtLantikanPertama" :state="getValidation(validationContext)" />
                        </b-col>
                    </b-row>
                </validation-provider>
                <!-- <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row> -->
                <validation-provider name="Amaun Telah Terima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Amaun Dalam Buku Servis </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-input v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Tarikh Kuatkuasa* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <base-input type="date" v-model="Obj.DtLantikanPertama" :state="getValidation(validationContext)" />
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row>
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Catatan* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">

                            <b-form-textarea v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input" rows="4" maxlength="1000" ></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->
                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    data() {
        return {
            programer: {
                anip: "bijak",
            },
            Obj: {
Catatan: "Gaji Lantikan Pertama"
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            skimOptions: [{
                    value: '2',
                    text: 'SSPA'
                },
                {
                    value: '1',
                    text: 'SSM'
                },
            ],
        };
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log(this.ServClassId);

            let Search = {
                ServClassId: this.Obj.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    this.Obj.SalGrdID = '';
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.Obj.ServClassId,
                SchmOfServId: this.Obj.SchmOfServId,
                pilihSkim: this.Obj.id_SistemSaraan,
            };
            console.log("this Search2", Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {
            (this.Obj.coid = Store.state.MaklumatPeribadi.coid),
            (this.Obj.elemenId = 1),
            (this.Obj.tahun = moment(
                this.Obj.DtLantikanPertama,
                "YYYY-MM-DD"
            ).format("YYYY")),
            console.log("log", this.Obj);

            GetsalaryService.setElemen(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {
                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }

            });

            //console.log("StatusSimpan", this.StatusSimpan);

        },
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        },
        filteredSchmOfServList() {
            const that = this

            return this.SchmOfServList.filter(x => x.ServClassId == that.Obj.ServClassId)

        },

        //  filteredSalGrdList() {
        //     const that = this

        //     return this.SalGrdList.filter( x => x.SchmOfServId == that.Obj.ServClassId)

        //  }
    },
    created() {
        //this.Obj = Store.state.MaklumatPeribadi;
        Object.assign(this.Obj, Store.state.MaklumatPeribadi);
        if (!this.Obj.Catatan) {
        this.Obj.Catatan = "Gaji Lantikan Pertama";
    }
        this.Obj.DtLantikanPertama = moment(
            this.Obj.DtLantikanPertama,
            "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log("maklumat catatan", this.Obj);
        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });
    },
};
</script>
